import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";
import { DialogHeader } from "../../auth/components/PasswordRecoveryModal";
import DangerBaseButton from "./DangerBaseButton";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useContext } from "react";
import { MainContext } from "../context/MainContextProvider";

export function ErrorModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose?: () => void;
  title: string;
  contentText: string;
  errorDetails?: string;
}) {
  const { open, setOpen, errorDetails } = props;
  const { setToastNotifications } = useContext(MainContext);
  const onClose = () => {
    setOpen(false);
    props.onClose && props.onClose();
  };
  const onShowErrorDetails = () => {
    setToastNotifications({
      isAdding: true,
      notifications: [
        {
          severity: "error" as const,
          text: errorDetails,
        },
      ],
    });
  };
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader
        sx={{
          display: "flex",
          alignItems: "center",
        }}
        id="customized-dialog-title"
        onClose={onClose}
      >
        {props.title}
        {errorDetails && (
          <Box
            sx={{ cursor: "pointer", paddingLeft: "8px" }}
            onClick={onShowErrorDetails}
          >
            <ErrorOutlineIcon
              sx={{
                color: "#f44336",
                width: 16,
                marginBottom: "1px",
              }}
            />
          </Box>
        )}
      </DialogHeader>
      <DialogContent
        sx={{
          width: "450px",
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        dividers
      >
        <Typography gutterBottom>{props.contentText} </Typography>
      </DialogContent>
      <DialogActions>
        <DangerBaseButton
          variant="contained"
          onClick={onClose}
          title="Fechar"
        />
      </DialogActions>
    </Dialog>
  );
}
